module.exports = __webpack_public_path__ + "static/media/Amelia_Island_Museum_of_History_Faux_painted_bricks_on_wooden_box_2004.e97d7ff9.webp";